<template>
    <modal
        name="liberarAsiento"
        transition="pop-out"
        :width="800"
        height="auto"
        :scrollable="true"
        :adaptive="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row m-0">
                    <div class="col-10 p-0 text-center">
                        <h3 class="m-0 ml-5 pl-4">{{$t('perfil.asiento_liberado_confirmacion')}}</h3>
                    </div>
                    <div class="col-2 p-0">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body text-center">
                <p class="title">{{$t('perfil.asiento_liberado_terminos')}}</p>
                <Button class="mr-2" type="button" name="button" @click.prevent="liberarAsiento()">{{$t('perfil.asiento_liberado_SI')}}</Button>
                <Button type="button" name="button" @click.prevent="close()">{{$t('perfil.asiento_liberado_NO')}}</Button>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close()">{{$t('perfil.asiento_liberado_cerrar')}}</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    export default {
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'liberarAsiento');
            },
            liberarAsiento() {
                this.$emit('liberar');
                this.close();
            }
        }
    }
</script>
